import { Component } from "@builder.io/sdk";

export const headerCareersConfig: Component = {
  name: "Careers Headers",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "header-careers",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      helperText: "Additional CSS classes for the section",
      advanced: true,
    },
    {
      name: "backgroundColor",
      type: "enum",
      enum: ["white", "orange-light"],
      friendlyName: "Background Color",
      defaultValue: "white",
      helperText:
        "Background color for the header section (white or light orange)",
    },
    {
      name: "headingClassName",
      type: "string",
      helperText: "Tailwind CSS classes for the heading text",
      advanced: true,
    },
    {
      name: "subheadingClassName",
      type: "string",
      helperText: "Tailwind CSS classes for the subheading text",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      required: true,
      defaultValue: "Build a Rewarding Career",
      helperText: "Main heading for the section",
    },
    {
      name: "subheading",
      type: "string",
      required: true,
      defaultValue: "Join one of Bay Area's Best Workplaces in Aging Services.",
      helperText: "Subheading text that appears below the main heading",
    },
    {
      name: "description",
      type: "richText",
      defaultValue:
        "Care Indeed is a leading Bay Area home care provider, recognized for innovations like virtual reality caregiver training. Founded by two nurses in 2010, it has grown to 700+ employees across four offices and is ranked by Fortune as a top workplace in Aging Services. We're seeking compassionate and driven professionals to join our team and make a meaningful impact.",
      helperText: "Descriptive text that appears below the subheading",
    },
    {
      name: "legacyButton",
      type: "boolean",
      defaultValue: false,
      helperText:
        "Whether to apply the legacy button styles in Tablet and Mobile view",
    },
    {
      name: "showPrimaryCTA",
      type: "boolean",
      defaultValue: true,
      helperText: "Whether to show the primary call-to-action button",
    },
    {
      name: "primaryCTA",
      type: "object",
      subFields: [
        {
          name: "children",
          type: "string",
          friendlyName: "Button Text",
          helperText: "Text for the primary call-to-action button",
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button URL",
          helperText: "URL or anchor link for the button",
        },
        {
          name: "color",
          type: "enum",
          enum: ["orange", "teal", "orange-light", "gray"],
          friendlyName: "Color",
          helperText: "Color theme for the button",
        },
        {
          name: "className",
          type: "string",
          friendlyName: "Button Class",
          helperText: "Additional CSS classes for the button",
          advanced: true,
        },
      ],
      defaultValue: {
        children: "Apply Now",
        href: "#careers-application-form",
        color: "orange",
        className: "w-fit",
      },
      helperText: "Primary call-to-action button configuration",
    },
    {
      name: "showSecondaryCTA",
      type: "boolean",
      defaultValue: true,
      helperText: "Whether to show the secondary call-to-action button",
    },
    {
      name: "secondaryCTA",
      type: "object",
      subFields: [
        {
          name: "children",
          type: "string",
          friendlyName: "Button Text",
          helperText: "Text for the secondary call-to-action button",
        },
        {
          name: "href",
          type: "string",
          friendlyName: "Button URL",
          helperText: "URL for the button",
        },
        {
          name: "color",
          type: "enum",
          enum: ["orange", "teal", "gray"],
          friendlyName: "Color",
          helperText: "Color theme for the button",
        },
        {
          name: "className",
          type: "string",
          friendlyName: "Button Class",
          helperText: "Additional CSS classes for the button",
          advanced: true,
        },
      ],
      defaultValue: {
        children: "Open Positions",
        href: "/healthcarestaffing",
        color: "gray",
        className: "w-fit",
      },
      helperText: "Secondary call-to-action button configuration",
    },
    {
      name: "image",
      type: "object",
      subFields: [
        {
          name: "src",
          type: "file",
          required: true,
          allowedFileTypes: ["jpeg", "png", "webp"],
          friendlyName: "Image",
          helperText: "Image URL",
        },
        {
          name: "alt",
          type: "string",
          friendlyName: "Alt Text",
          helperText: "Alt text for the image",
        },
      ],
      defaultValue: {
        src: "https://cdn.builder.io/api/v1/image/assets%2Fad5264505ff74b8ba929a635f7c3c34f%2F691653f3fd044e258fba3be0ffb5c06b",
        alt: "Caregiver in an orange uniform smiles warmly while holding hands with an elderly man on a couch in a cozy living room.",
      },
      helperText: "Header image configuration",
    },
  ],
};
